import { Navigate, Route, Routes, useLocation, useNavigate } from "react-router-dom";

import AppInfo from "containers/AppInfo";
import Help from "containers/Help";
import Settings from "containers/Settings";
import NewGroup from "containers/NewGroup";
import AddFriend from "containers/AddFriend";
import Friends from "containers/Friends";
import ConfirmResetPassword from "containers/ConfirmResetPassword";
import SetEvent from "containers/SetEvent";
import Event from "containers/Event";
import AddGroupUsers from "containers/AddGroupUsers";
import TimelineEventDetails from "containers/TimelineEventDetails";
import GroupTimeline from "containers/GroupTimeline";
import GroupSettings from "containers/GroupSettings";
import Group from "containers/Group";
import Groups from "containers/Groups";
import EventParticipantsVotes from "routes/with-metadata/EventParticipantsVotes";
import TimelineEventParticipantsVotes from "routes/with-metadata/TimelineEventParticipantsVotes";
import EventPendingVotes from "routes/with-metadata/EventPendingVotes";
import TimelineEventPendingVotes from "routes/with-metadata/TimelineEventPendingVotes";
import EventVehiclesVotes from "routes/with-metadata/EventVehiclesVotes";
import TimelineEventVehiclesVotes from "routes/with-metadata/TimelineEventVehiclesVotes";
import SecretSanta from "apps/SecretSanta";
import MoneyManager from "apps/MoneyManager";
import TimelineMoneyManager from "apps/MoneyManager/TimelineMoneyManager";
import RoomManager from "apps/RoomManager";
import TimelineRoomManager from "apps/RoomManager/TimelineRoomManager";
import TimelineSecretSanta from "apps/SecretSanta/TimelineSecretSanta";
import GroupInviteLink from "containers/GroupInviteLink";

function MobilePrivateRoutes() {
  const navigate = useNavigate();
  const location = useLocation();
  const url = location.pathname;

  return (
    <Routes>
      <Route path='/settings/help/app-info' element={<AppInfo />} />
      <Route path='/settings/help' element={<Help onViewAppInfo={() => navigate(`${url}/app-info`)} />} />
      <Route path='/settings' element={<Settings onViewHelp={() => navigate(`${url}/help`)} />} />
      <Route
        path='/new-group'
        element={<NewGroup onAddFriends={() => navigate("/friends/add-friend")} onCreateGroup={() => navigate(-1)} />}
      />
      <Route path='/friends/add-friend' element={<AddFriend />} />
      <Route path='/friends' element={<Friends onAddFriends={() => navigate("/friends/add-friend")} />} />
      <Route path='/confirm-reset-password' element={<ConfirmResetPassword />} />
      <Route path='/group/:groupId/event/:eventId/apps/secret-santa' element={<SecretSanta />} />
      <Route path='/group/:groupId/event/:eventId/apps/money-manager' element={<MoneyManager />} />
      <Route path='/group/:groupId/event/:eventId/apps/room-manager' element={<RoomManager />} />
      <Route path='/group/:groupId/event/:eventId/set-event' element={<SetEvent onSetEvent={() => navigate(-1)} />} />
      <Route path='/group/:groupId/set-event' element={<SetEvent onSetEvent={() => navigate(-1)} />} />
      <Route path='/group/:groupId/event/:eventId/participants' element={<EventParticipantsVotes />} />
      <Route path='/group/:groupId/event/:eventId/pending' element={<EventPendingVotes />} />
      <Route path='/group/:groupId/event/:eventId/vehicles' element={<EventVehiclesVotes />} />
      <Route
        path='/group/:groupId/event/:eventId'
        element={
          <Event
            onEditEvent={() => navigate(`${url}/set-event`)}
            onEventAppsMenuItemClick={(route) => navigate(`${url}/${route}`)}
            onViewParticipants={() => navigate(`${url}/participants`)}
            onViewPending={() => navigate(`${url}/pending`)}
            onViewVehicles={() => navigate(`${url}/vehicles`)}
          />
        }
      />
      <Route path='/group/:groupId/settings/invite-link' element={<GroupInviteLink />} />
      <Route
        path='/group/:groupId/settings/add-user'
        element={<AddGroupUsers onAddGroupUsers={() => navigate(-1)} />}
      />
      <Route
        path='/group/:groupId/settings/timeline/:eventId/participants'
        element={<TimelineEventParticipantsVotes />}
      />
      <Route path='/group/:groupId/settings/timeline/:eventId/pending' element={<TimelineEventPendingVotes />} />
      <Route path='/group/:groupId/settings/timeline/:eventId/vehicles' element={<TimelineEventVehiclesVotes />} />
      <Route path='/group/:groupId/settings/timeline/:eventId/apps/secret-santa' element={<TimelineSecretSanta />} />
      <Route path='/group/:groupId/settings/timeline/:eventId/apps/money-manager' element={<TimelineMoneyManager />} />
      <Route path='/group/:groupId/settings/timeline/:eventId/apps/room-manager' element={<TimelineRoomManager />} />
      <Route
        path='/group/:groupId/settings/timeline/:eventId'
        element={
          <TimelineEventDetails
            onEventAppsMenuItemClick={(route) => navigate(`${url}/${route}`)}
            onViewParticipants={() => navigate(`${url}/participants`)}
            onViewPending={() => navigate(`${url}/pending`)}
            onViewVehicles={() => navigate(`${url}/vehicles`)}
          />
        }
      />
      <Route path='/group/:groupId/settings/timeline' element={<GroupTimeline />} />
      <Route
        path='/group/:groupId/settings'
        element={
          <GroupSettings
            onAddUsers={() => navigate(`${url}/add-user`)}
            onInviteLink={() => navigate(`${url}/invite-link`)}
            onViewTimeline={(group) => navigate(`${url}/timeline`, { state: { groupId: group.id } })}
          />
        }
      />
      <Route
        path='/group/:groupId'
        element={
          <Group
            onCreateEventClick={() => navigate(`${url}/set-event`, {})}
            onEventClick={(event) => navigate(`${url}/event/${event.id}`)}
            onGroupSettingsClick={() => navigate(`${url}/settings`)}
          />
        }
      />
      <Route
        path='/change-log'
        element={
          <Groups
            onCreateGroupClick={() => navigate("/new-group")}
            onFriendsClick={() => navigate("/friends")}
            onGroupClick={(group) => navigate(`/group/${group.id}`)}
            onSettingsClick={() => navigate("/settings")}
          />
        }
      />
      <Route
        path='/'
        element={
          <Groups
            onCreateGroupClick={() => navigate("/new-group")}
            onFriendsClick={() => navigate("/friends")}
            onGroupClick={(group) => navigate(`/group/${group.id}`)}
            onSettingsClick={() => navigate("/settings")}
          />
        }
      />
      <Route element={<Navigate to='/' replace />} />
    </Routes>
  );
}

export default MobilePrivateRoutes;
